<template>
  <span
    class="material-icon"
    :style="{ fontSize: `${ this.size }px`, color: `${ this.color }` }"
    v-if="this.name"
  >{{ this.name }}</span>
</template>

<script>
export default {
  name: 'BaseIcon',
  props: {
    name: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: '24'
    },
    color: {
      type: String,
      default: 'inherit'
    }
  }
}
</script>

<style>
.material-icon {
  color: inherit;
  font-family: 'Material Icons';
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  display: inline-block;
  line-height: 1;
  text-transform: none;
  letter-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  direction: ltr;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
  font-feature-settings: 'liga';
  font-display: block;
}
</style>